import { BsBoxArrowUpRight } from "react-icons/bs";

import '../../styles/Animator.css';

import '../../styles/Purpose.css';

export function CardServicePanel({ links }) {
  return(
    <>
      <div className="columns">
        {
          links.map((link)=>(
            <div key={link.service} className="column is-half">
              <div className="card m-5">
                

              <div className="card-image image-container floating">
                <figure className="image is-128x128">
                  <img src={`./img/${link.img}`} alt={link.service} />
                </figure>
              </div>

                <div className="card-content has-background-primary">
                  <p className="title has-text-centered has-text-light">
                    {link.service}
                  </p>
                  <p className="subtitle has-text-centered has-text-secondary">
                    {link.text}
                  </p>
                </div>
                
                <a href={link.url} target='_blank'>
                  <footer className="card-footer has-background-warning">
                    <p className="card-footer-item">
                      <BsBoxArrowUpRight />
                    </p>
                  </footer>
                </a>
              </div>
            </div>
          ))
        }
      </div>
    </>
  );
}